import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import Swal from "sweetalert2";
import axios from "../../common/axios";
import { userState } from "../../common/atom/userState";
import { useLogout } from "../../common/logout";

// Header.js의 세션 만료 카운트다운 + 연장 로직 포팅
export default function SessionRemain() {
  const [{ expiresIn, sessionUpdatedAt }, setUser] = useRecoilState(userState);
  const [remain, setRemain] = useState(expiresIn);
  const logout = useLogout();

  useEffect(() => {
    if (expiresIn === null) return;
    setRemain(expiresIn);
  }, [sessionUpdatedAt, expiresIn]);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemain((r) => (r == null ? r : r > 0 ? r - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const extendSession = async () => {
    const result = await Swal.fire({
      title: "세션 연장을 하시겠습니까?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "네",
      cancelButtonText: "아니오",
    });
    if (!result.isConfirmed) return;
    try {
      const res = await axios.post("/session/refresh", {}, { withCredentials: true });
      if (res.data.ok === true && typeof res.data.expiresIn === "number") {
        setUser((prev) => ({
          ...prev,
          expiresIn: res.data.expiresIn,
          sessionUpdatedAt: Date.now(),
        }));
        Swal.fire({ title: "세션 연장", icon: "success", text: "세션이 연장되었습니다." });
        return;
      }
      // 응답 형식이 비정상이면 세션 실패로 간주해 로그아웃 처리 (fail-closed)
      await Swal.fire({ title: "세션 연장 실패", icon: "error", text: "다시 로그인하세요." });
      logout();
    } catch (err) {
      await Swal.fire({ title: "세션 연장 실패", icon: "error", text: "다시 로그인하세요." });
      logout();
    }
  };

  if (remain === null || remain === undefined) return null;

  return (
    <button
      type="button"
      onClick={extendSession}
      className="flex items-center gap-1.5 rounded-md border border-border bg-muted/50 px-2.5 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
    >
      세션 만료까지 {Math.floor(remain / 60)}:{(remain % 60).toString().padStart(2, "0")} (연장)
    </button>
  );
}
